import { render, staticRenderFns } from "./objectClose.vue?vue&type=template&id=bcefa058&"
import script from "./objectClose.vue?vue&type=script&lang=js&"
export * from "./objectClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports